module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/paremployee-routes/paremployee-routes.component.css
// module id = ./src/app/components/paremployee-routes/paremployee-routes.component.css
// module chunks = main